<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5"> Ações do Convênio </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-tabela
                        idTabela="tblAcoes"
                        :itens="acoes"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <btn-inserir-acao
                                    v-if="$temAcessoView('CONV-ACO-01')"
                                    :convenio="convenio"
                                    @atualizarListaAcoes="atualizarListaAcoes()"
                                ></btn-inserir-acao>
                            </b-button-group>
                        </template>
                        <template slot="acoes" slot-scope="data">
                            <btn-atualizar-acao
                                v-if="$temAcessoView('CONV-ACO-03')"
                                :convenio="convenio"
                                :acao="data"
                                @atualizarListaAcoes="atualizarListaAcoes()"
                            ></btn-atualizar-acao>
                            <btn-excluir-acao
                                v-if="
                                    $temAcessoView('CONV-ACO-02') &&
                                    data.permiteExcluir
                                "
                                :convenio="convenio"
                                :acao="data"
                                @atualizarListaAcoes="atualizarListaAcoes()"
                            ></btn-excluir-acao>
                        </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import ConveniosServicos from '../ConveniosServicos'
import BtnInserirAcao from '../cadastro/acoes/BtnInserirAcao'
import BtnAtualizarAcao from '../cadastro/acoes/BtnAtualizarAcao'
import BtnExcluirAcao from '../cadastro/acoes/BtnExcluirAcao'

export default {
    components: {
        BtnInserirAcao,
        BtnAtualizarAcao,
        BtnExcluirAcao
    },

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            itensPorPagina: 5,
            acoes: [],
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        atualizarListaAcoes() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data.acoes
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    watch: {
        convenio() {
            if (this.convenio) {
                this.acoes = this.convenio.acoes
            }
        }
    }
}
</script>
